module.exports = __webpack_public_path__ + "media/images/gallery/gal_l-b704e20bb396710805acc4592f987fca.gif";